import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function TotpVerify() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { setAuthData } = useAuth();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  useEffect(() => {
    if (!localStorage.getItem('tempToken')) {
      navigate('/login');
    }
    inputRef.current?.focus();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (code.length !== 6) return;
    setLoading(true);
    try {
      const tempToken = localStorage.getItem('tempToken');
      const res = await api.post('/auth/totp/verify', { code }, {
        headers: { Authorization: `Bearer ${tempToken}` }
      });
      const tempRefresh = localStorage.getItem('tempRefreshToken');
      localStorage.removeItem('tempToken');
      localStorage.removeItem('tempRefreshToken');
      // JWT payload dekodieren für user-Objekt
      const payload = JSON.parse(atob(res.data.accessToken.split('.')[1]));
      const userData = { id: payload.id, first_name: payload.first_name, last_name: payload.last_name, email: payload.email, role: payload.role, modules: payload.modules };
      setAuthData({ accessToken: res.data.accessToken, refreshToken: tempRefresh, user: userData });
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Ungültiger Code');
      setCode('');
      inputRef.current?.focus();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sidebar flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white tracking-tight">Emge Computer</h1>
          <p className="text-sidebar-text mt-2 text-sm">Zwei-Faktor-Authentifizierung</p>
        </div>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <div className="text-center mb-6">
            <div className="w-14 h-14 bg-primary-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
              <svg className="w-7 h-7 text-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
            </div>
            <h2 className="text-lg font-semibold text-gray-800">Code eingeben</h2>
            <p className="text-sm text-gray-500 mt-1">Öffnen Sie Ihre Authenticator-App und geben Sie den 6-stelligen Code ein.</p>
          </div>
          <form onSubmit={handleSubmit} className="space-y-5">
            <input
              ref={inputRef}
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
              className="w-full border border-gray-200 rounded-xl px-4 py-3 text-center text-2xl font-mono tracking-widest focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-gray-50 transition-all"
              placeholder="000000"
              required
            />
            <button
              type="submit"
              disabled={loading || code.length !== 6}
              className="w-full bg-primary-500 hover:bg-primary-600 text-white font-semibold py-3 px-4 rounded-xl text-sm transition-all disabled:opacity-50 shadow-lg shadow-primary-500/25"
            >
              {loading ? 'Prüfen...' : 'Bestätigen'}
            </button>
          </form>
          <p className="text-center text-xs text-gray-400 mt-4">
            Zurück zur <a href="/login" className="text-primary-500 hover:underline">Anmeldung</a>
          </p>
        </div>
      </div>
    </div>
  );
}
